import React, { createContext, useState } from 'react';
import { getGraphicTransitionModuleColors, getInitialActiveSlideMap, } from '../../utils/graphicTransitionUtils';
export const GraphicTransitionContext = createContext({
    getTransitionColors: undefined,
    showCarouselSlide: undefined,
});
export const GraphicTransitionProvider = ({ children, allModules, }) => {
    const [activeSlideMap, setActiveSlideMap] = useState(getInitialActiveSlideMap(allModules));
    const showCarouselSlide = (mod, slide) => {
        if (mod.id) {
            const tempActiveSlideMap = activeSlideMap;
            tempActiveSlideMap === null || tempActiveSlideMap === void 0 ? void 0 : tempActiveSlideMap.set(mod.id, slide);
            setActiveSlideMap(tempActiveSlideMap);
        }
    };
    const getTransitionColors = (transitionModuleIndex) => {
        return getGraphicTransitionModuleColors(allModules, transitionModuleIndex, activeSlideMap);
    };
    return (React.createElement(GraphicTransitionContext.Provider, { value: { showCarouselSlide, getTransitionColors } }, children));
};
//# sourceMappingURL=GraphicTransitionContext.js.map